import React from 'react';
import './software-download.styles.scss';

import UserInfoDisplay from '../../../components/ecommerce/user-info-display/user-info-display.component';
import FilteredLoginInfo from '../../../components/ecommerce/filtered-login-info/filtered-login-info.component';
import {useDispatch, useSelector} from "react-redux";
import {getClientData} from "../../../redux/clientdata/client.action";

function SoftwareDownload() {

    return (
        <div className="software-download module-spacer">
            <div className="trinity-container">
                <UserInfoDisplay/>
                <hr className="section-seperator"/>
            </div>

            <FilteredLoginInfo/>

        </div>
    )
}

export default SoftwareDownload;